import React from "react";
import { Box, Button, Stack, Grid, styled, Typography } from "@mui/material";
import { Text } from "./style";
import BillsImg from "../../images/landing/gst bills.png";
import GstFill from "../../images/landing/gst fill.png";
import InoviceImg from "../../images/landing/inovice gen.png";
import EcommerceImg from "../../images/landing/e-commerce.png";
import InventoryImg from "../../images/landing/inventory img.png";

const Title = styled(Typography)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: 600,
  fontSize: "36px",
  color: "#60656C",
  [theme.breakpoints.down("md")]: {
    fontSize: "25px",
    textAlign: "center",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "20px",
    textAlign: "center",
  },
}));
const GridBox = styled(Grid)(({ theme }) => ({
  margin: "50px 0",
  alignItems: "center",
  justifyContent: "space-between",
  flexDirection: "row",
}));
const ReverseGrid = styled(Grid)(({ theme }) => ({
  margin: "50px 0",
  alignItems: "center",
  justifyContent: "space-between",
  flexDirection: "row",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column-reverse",
  },
}));

export default function UsesSection() {
  return (
    <Box sx={{ pt: 5, pb: "20px" }}>
      <GridBox container alignItems="center">
        <Grid item md={5} xs={12} sx={{ width: { xs: "80%", md: "100%" } }}>
          <img width="90%" src={BillsImg} alt="" />
        </Grid>
        <Grid item md={6} xs={12}>
          <Title>Create GST Bills for customers and share them online</Title>
          <Text>
            ManageKaro billing software helps you set up a professional brand
            identity with our most popular GST billing feature. You can use
            ManageKaro accounting and billing app to create invoices.
          </Text>
        </Grid>
      </GridBox>
      <ReverseGrid container alignItems="center">
        <Grid item md={6} xs={12}>
          <Title>Manage inventory seamlessly</Title>
          <Text>
            ManageKaro brings the finest inventory management software with
            incredibly effective features. Improve your business performance by
            managing your inventory efficiently. Using our advanced analytics
            generate business reports, track your sales and plan ahead for
            changing demand cycle. ManageKaro will help you in optimising your
            inventory management to reduce costs and increase profitability.
          </Text>
        </Grid>
        <Grid item md={5} xs={12} sx={{ width: { xs: "80%", md: "100%" } }}>
          <img width="100%" src={InventoryImg} alt="" />
        </Grid>
      </ReverseGrid>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item md={5} xs={12} sx={{ width: { xs: "80%", md: "100%" } }}>
          <img width="100%" src={GstFill} alt="" />
        </Grid>
        <Grid item md={6} xs={12}>
          <Title>GST Filing made simple and faster</Title>
          <Text>
            Filing GST is a challenge for business owners and is a long tedious
            process if done manually. Using ManageKaro billing software, you can
            create GST reports and make the GST filing process seamless.
          </Text>
        </Grid>
      </Grid>
      <GridBox container alignItems="center">
        <Grid item md={6} xs={12}>
          <Title>Easy to use Invoice generator</Title>
          <Text>
            Sending invoices is a vital aspect of any business. Our online
            invoice tool allows you to receive payments from your customers
            without any hassle, helping you to maintain a positive cash flow
            with updated ledgers.
          </Text>
        </Grid>
        <Grid item md={5} xs={12} sx={{ width: { xs: "80%", md: "100%" } }}>
          <img width="100%" src={InoviceImg} alt="" />
        </Grid>
      </GridBox>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item md={5} xs={12} sx={{ width: { xs: "80%", md: "100%" } }}>
          <img width="100%" src={EcommerceImg} alt="" />
        </Grid>
        <Grid item md={6} xs={12}>
          <Title>
            Launch your online e-commerce store and start selling online
          </Title>
          <Text>
            With ManageKaro you can instantly launch your e-commerce store with
            a unique link of all your products. Share the link with your
            customers and start selling online instantly.
          </Text>
        </Grid>
      </Grid>
    </Box>
  );
}
